(function () {
  function init() {
    var left = document.querySelector('.dsgn-pck__block-id-text_KWWBfz .dsgn-pck__text');
    var right = document.querySelector('.dsgn-pck__block-id-text_QT4Rg8 .dsgn-pck__text');
    if (!left || !right) return;
    var words = left.querySelectorAll('h2');
    var descs = right.querySelectorAll('p');
    if (!words.length || !descs.length) return;
    var group = left.closest('.dsgn-pck__grid-columns') || left.parentNode;

    function activate(i) {
      group.classList.add('values-hovering');
      for (var a = 0; a < words.length; a++) words[a].classList.toggle('values-active', a === i);
      for (var b = 0; b < descs.length; b++) descs[b].classList.toggle('values-active', b === i);
    }
    function clear() {
      group.classList.remove('values-hovering');
      for (var a = 0; a < words.length; a++) words[a].classList.remove('values-active');
      for (var b = 0; b < descs.length; b++) descs[b].classList.remove('values-active');
    }
    words.forEach(function (w, i) { w.addEventListener('mouseenter', function () { activate(i); }); });
    descs.forEach(function (d, i) { d.addEventListener('mouseenter', function () { activate(i); }); });
    group.addEventListener('mouseleave', clear);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
